import {createContext, useContext} from 'react';

export const ModalTitleIdContext = createContext<string | undefined>(undefined);

export function useModalTitleId() {
  return useContext(ModalTitleIdContext);
}
